import { render } from "./TextBanner.vue?vue&type=template&id=492b5fd4"
import script from "./TextBanner.vue?vue&type=script&lang=js"
export * from "./TextBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__